import Cookies from "js-cookie";

export const userReducer = (state, action) => {
    switch (action.type) {
        case "LOGIN":
            Cookies.set("username", action.username);
            Cookies.set("adminId", action.adminId);
            Cookies.set("userId", action.userId);
            return true;

        case "LOGOUT":
            Cookies.remove("username");
            Cookies.remove("adminId");
            Cookies.remove("userId");
            return false;

        default:
            return false;
    }
};
